import React from "react";
import "./App.css";
import { Calendar } from "./components/Calendar";

function App() {
  return (
    <div className="App">
      <header>
        <div>
          <h1>Memento Mori</h1>
          <p>Remember that you will [have to] die.</p>
        </div>
      </header>
      <Calendar />
    </div>
  );
}

export default App;
